/* ==========================================================================

  Model for example localisation tests

  Author:     Stephen Zsolnai (http://www.zolla.co.uk)
  Decription: THIS FILE IS NOT MEANT FOR PRODUCTION AND WILL BE EXCLUDED WITH GRUNT DIST TASK
              This file task in the model specified at: http://private-3c022f-bioarrow.apiary-mock.com/localisation-tests
              and transforms it to fit the formatting needed by the handlebars translate helper to effectively map it to keys for translations.

              IN MOST INSTANCES YOU WILL NOT HAVE TO TRANSFORM THE DATA TO FIT THE MAPPING.
              Backend will hopefully structure the parameters to the same level in the mapping and the data objects
              Details of how this works can be found here: http://localhost:3000/dev-views/handlebars-translations.html
========================================================================== */

'use strict';

//Typeahead Config
var Backbone = require('backbone'),

  LocalisationTestsModel = Backbone.Model.extend({
    urlRoot: '/api/localisation/translation-pluralisation',
    parse: function(response) {

      //Very obtuse examples to illustrate how we may have to create these transformations to map to the key mappings.

      response.userName = response.user.name;

      response.counts = {
        basketCount: response.basket.count,
        wishlistCount: response.wishlist.count
      };

      response.userAndCount = {
        userName: response.user.name,
        basketCount: response.basket.count
      };

      response.userAndCounts = {
        userName: response.user.name,
        basketCount: response.basket.count,
        wishlistCount: response.wishlist.count
      };

      return response;
    }
  });

module.exports = LocalisationTestsModel;



// WEBPACK FOOTER //
// ./assets/js/frontend-only/localisationTestsModel.js